import React, { useEffect, useState } from "react";
import "../src/styles/global.scss";

//Librerie esterne
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { CssBaseline, ThemeProvider, Box } from "@mui/material";
import { getTheme } from "./styles/theme";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

//Utils
import { isEmpty } from "./utils/validation";

//Components
import Sidebar from "./components/sidebar/Sidebar";
import Headerbar from "./components/headerbar/Headerbar";
import SnackBar from "./components/snackbar/SnackBar";

//Pages
import Login from "../src/pages/login/Login";
import Users from "../src/pages/users/Users";
import Associations from "../src/pages/associations/Associations";
import ActivationCode from "../src/pages/activationCode/ActivationCode";
import Server from "../src/pages/server/Server";
import Logs from "../src/pages/logs/Logs";

const MainLayout = ({ toggleColorMode }) => {
  const navigate = useNavigate();
  const location = useLocation(); // Hook che fornisce la location corrente

  useEffect(() => {
    if (isEmpty(localStorage.getItem("accessToken"))) {
      navigate("/login");
    }
  }, [location.pathname]);

  return (
    <Box sx={{ display: "flex" }}>
      <Sidebar />
      <Box component="main" sx={{ flexGrow: 1, p: 3, minHeight: "100vh" }}>
        {/* HeaderBar separato */}
        <Headerbar toggleColorMode={toggleColorMode} />

        {/* Contenuto dinamico */}
        <Outlet />
      </Box>
      <SnackBar />
    </Box>
  );
};

function App() {
  const [mode, setMode] = useState("dark"); // oppure 'dark'
  const theme = getTheme(mode);

  // Funzione che alterna il tema
  const toggleColorMode = () => {
    setMode((prev) => (prev === "light" ? "dark" : "light"));
  };

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Routes>
          {/* Pages con layout */}
          <Route element={<MainLayout toggleColorMode={toggleColorMode} />}>
            <Route path="/" element={<Users />} />
            <Route path="/associations" element={<Associations />} />
            <Route path="/activation-code" element={<ActivationCode />} />
            <Route path="/server" element={<Server />} />
            <Route path="/logs" element={<Logs />} />
          </Route>

          {/* Pages SENZA layout */}
          <Route path="/login" element={<Login />} />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;
